import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import CssIcon from '../Icon/Icon.js';
import StyledButton from './Button.style.js';

const Button = (_ref) => {
  let {
    children,
    icon,
    variant,
    iconAlignment,
    disabled
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "icon", "variant", "iconAlignment", "disabled"]);

  return /*#__PURE__*/React$1.createElement(StyledButton, _extends({
    icon: icon,
    variant: variant
  }, props), /*#__PURE__*/React$1.createElement("span", {
    className: "button__label"
  }, icon && iconAlignment === 'before' && /*#__PURE__*/React$1.createElement(CssIcon, {
    icon: icon,
    alignment: "left"
  }), children, icon && iconAlignment === 'after' && /*#__PURE__*/React$1.createElement(CssIcon, {
    icon: icon,
    alignment: "right"
  })));
};

Button.propTypes = {
  children: PropTypes$1.node.isRequired,
  icon: PropTypes$1.string,
  variant: PropTypes$1.oneOf(['primary', 'secondary']),
  iconAlignment: PropTypes$1.oneOf(['before', 'after']),
  disabled: PropTypes$1.bool
};
Button.defaultProps = {
  icon: 'default',
  variant: 'primary',
  iconAlignment: 'after',
  disabled: false
};

export default Button;
